<template>
	<Layout :loading="loading" :pageTitle="title" :backlink="`/orders`">
		<template #cta>
			<div class="d-flex">
				<div class="btn btn-light" v-if="item && item.status == 'AWAITING_PAYMENT'" @click="registerPayment()">Registrar pago</div>
				<div class="btn btn-light" v-if="item && item.status == 'PROCESSING'" @click="setStatus('READY_TO_SHIP')">Marcar como procesada</div>
				<div class="btn btn-success" v-if="item && item.status == 'READY_TO_SHIP'" @click="setStatus('DELIVERED')">Marcar como entregada</div>

				<div class="" v-if="item && item.canCancel">
					<b-dropdown variant="link" no-caret right v-b-tooltip.hover title="Mas acciones" v-b-tooltip.left>
						<template v-slot:button-content><i class="icon icon-dot-3"></i></template>
						<b-dropdown-item @click="deletePrompt()">Cancelar orden</b-dropdown-item>
					</b-dropdown>
				</div>
			</div>
		</template>

		<div class="container-fluid" v-if="item">
			<div class="row">
				<div class="col">
					<div class="detail-boxes">
						<div class="box">
							<div class="data">
								<div class="label">Código</div>
								<div class="value">{{ item.code }}</div>
							</div>
							<div>
								<div class="icon icon-pound"></div>
							</div>
						</div>
						<div class="box">
							<div class="data">
								<div class="label">Fecha de compra</div>
								<div class="value">{{ item.createdAt | moment('DD-MM-YYYY HH:mm') }}</div>
							</div>
							<div>
								<div class="icon icon-ios-calendar-outline"></div>
							</div>
						</div>
						<div class="box">
							<div class="data">
								<div class="label">Cliente</div>
								<div class="value">{{ item.client.name }} {{ item.client.lastname }}</div>
							</div>
							<div>
								<div class="icon icon-man-people-streamline-user"></div>
							</div>
						</div>
						<div class="box">
							<div class="data">
								<div class="label">Monto total</div>
								<div class="value"><small>U$S</small> {{ item.priceTotal.toFixed(2) }}</div>
							</div>
							<div>
								<div class="icon icon-social-usd"></div>
							</div>
						</div>
						<div class="box">
							<div class="data">
								<div class="label">Estado</div>
								<div class="value">
									<span class="d-flex ">
										<i class="dot mt-1 mr-1" :class="`dot-${item.statusClass}`"></i>
										<span>{{ item.statusText }}</span>
									</span>
								</div>
							</div>
							<div>
								<!-- <div class="icon icon-social-usd"></div> -->
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col col-md-8 col-xl-9 ">
					<div class="mt-3">
						<OrderProductsTable :order="item" />
					</div>
				</div>
				<div class="col col-md-4 col-xl-3 border-left">
					<div class="mt-3 p-2">
						<ClientCard :client="item.client" :order="item" />
					</div>
					<hr />
					<div class="mt-3 p-2">
						<div class="label">INFORMACIÓN DE FACTURACIÓN</div>
						<div v-if="item.businessName && item.businessRut">
							<p class="mb-0 ml-2">
								<span class="text-secondary">Razón social:</span> {{ item.businessName }}<br />
								<span class="text-secondary">RUT:</span> {{ item.businessRut }}<br />
							</p>
						</div>
						<div class="alert alert-light" v-else>No ha ingresado información de facturación</div>
					</div>
					<hr />
					<div class="mt-3 p-2">
						<div class="label">INFORMACIÓN DE ENVÍO</div>

						<div v-if="item.deliveryMethod == 'OFFICE'" class="m-2">
							Retira en local
						</div>
						<div v-if="item.deliveryMethod == 'DELIVERY'" class="m-2">
							Envío a domicilio<br />
							<p class="mb-0 ml-2">
								<span class="text-secondary">Agencia:</span> {{ item.deliveryAgency }}<br />
								<span class="text-secondary">Localidad:</span> {{ item.deliveryLocality }}<br />
								<span class="text-secondary">Dirección:</span> {{ item.deliveryAddress }}<br />
								<span class="text-secondary">Comentarios:</span> <br />{{ item.deliveryComments }}
							</p>
						</div>
					</div>
					<hr />
					<div class="mt-3 p-2">
						<OrderPaymentCard :order="item" @update="load" />
					</div>
				</div>
			</div>
		</div>
		<OrderRegisterPayment ref="orderRegisterPayment" :order="item" @update="load" />
	</Layout>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import OrderProductsTable from './OrderProductsTable'
import ClientCard from '@/views/clients/ClientCard'
import OrderPaymentCard from './OrderPaymentCard'
import OrderRegisterPayment from './OrderRegisterPayment'

export default {
	name: 'OrderDetail',
	mixins: [mixins],
	components: {
		OrderProductsTable,
		ClientCard,
		OrderPaymentCard,
		OrderRegisterPayment,
	},
	data() {
		return {
			item: null,
			title: 'Detalle de orden',
			loading: false,
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		registerPayment() {
			this.$refs.orderRegisterPayment.open()
		},

		load() {
			this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							order(id: $id) {
								id
								code
								priceTotal
								client {
									id
									name
									lastname
									email
									phone {
										national
										international
									}
									documentText
									addressCountry {
										name
									}
									addressCity
									addressStreet
								}
								products {
									product {
										id
										name
										category {
											id
											title
										}
										image {
											id
											urlThumb
										}
									}
									qty
									priceUnit
									priceSubtotal
								}

								priceSubtotal
								priceTaxes
								priceTotal

								businessName
								businessRut

								deliveryMethod
								deliveryAgency
								deliveryLocality
								deliveryAddress
								deliveryComments

								paidAt
								processedAt
								deliveredAt
								cancelledAt
								refundedAt

								payments {
									id
									externalPaymentId
									amount
									installments
									paymentType
									paymentMethod
									paymentMethodName
									acquirerName
									acquirerIcon
									last4
									status
									statusText
									statusClass
								}

								paymentStatus
								paymentStatusText
								paymentStatusHelp
								paymentStatusClass

								createdAt
								status
								statusText
								statusClass

								canCancel
							}
						}
					`,
					fetchPolicy: 'network-only',
					variables: {
						id: this.$route.params.id,
					},
				})
				.then(({ data }) => {
					this.item = data.order
					this.title = `Orden de compra #${data.order.code}`
					this.loading = false
				})
				.catch(() => {})
		},

		setStatus(status) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $status: String!) {
							orderSetStatus(id: $id, status: $status) {
								id
							}
						}
					`,
					variables: {
						id: this.$route.params.id,
						status,
					},
				})
				.then(() => {
					this.$toast.success('Estado actualizado correctamente')
					this.load()
					this.saving = false
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		},

		deletePrompt() {
			this.$dialog
				.confirm(
					{
						title: 'Cancelar orden de compra',
						body: `¿Está seguro que desea cancelar la orden "#<strong>${this.item.code}"</strong>?`,
					},
					{
						okText: 'Cancelar',
						customClass: 'delete-prompt',
					},
					{
						cancelText: 'No cancelar',
					}
				)
				.then(() => {
					this.setStatus('CANCELLED')
				})
		},
	},
}
</script>

<style scoped>
.detail-boxes {
	background-color: #f5f7fb;
	display: flex;
	border-bottom: 1px solid #d3d9db;
}
.detail-boxes .box {
	padding: 8px 16px;
	height: 70px;
	border-right: 1px solid #d3d9db;
	display: flex;
	align-items: center;
	flex-grow: 1;
}
.detail-boxes .box:last-child {
	border: none;
}
.detail-boxes .box .data {
	flex-grow: 1;
}
.detail-boxes .box .label {
	text-transform: uppercase;
	color: #8c8c8c;
	font-size: 12px;
	line-height: 12px;
}
.detail-boxes .box .value {
	color: #333;
	font-size: 16px;
	line-height: 16px;
	font-weight: 500;
}
.detail-boxes .box .icon {
	color: #a9afbb;
	font-size: 18px;
}
</style>
